<template>
  <div>
    <manageAssistantTeacherBarVue />

    <!-- Toggle Mode Bar -->
   <v-toolbar color="primary" dark dense elevation="2">
      <v-toolbar-title class="font-weight-bold">
        <v-icon left>mdi-school</v-icon>
        ระบบรายงานตัวครูผู้ช่วย รอบที่
        {{ periodassteachs.periodAssTeachTimes }}/{{
          periodassteachs.periodAssTeachYear
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-chip class="mr-4" color="white" text-color="primary" label>
        <v-icon left small>mdi-account-group</v-icon>
        ทั้งหมด: {{ statistics.total }} คน
      </v-chip>

      <v-btn-toggle
        v-model="viewMode"
        mandatory
        dense
        color="info"
        class="mr-2 success--text"
        
      >
        <v-btn value="admin" small>
          <v-icon left small>mdi-cog</v-icon>
          จัดการ
        </v-btn>
        <v-btn value="display" small>
          <v-icon left small>mdi-monitor</v-icon>
          สถิติ
        </v-btn>
      </v-btn-toggle>

      <v-btn icon @click="toggleFullscreen" class="mr-1">
        <v-icon>{{
          isFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen"
        }}</v-icon>
      </v-btn>

      <v-btn
        icon
        @click="toggleAutoRefresh"
        :color="autoRefresh ? 'green' : ''"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Display Mode (Projector View) -->
    <div v-if="viewMode === 'display'" class="display-mode">
      <v-container
        fluid
        class="pa-6 grey lighten-4"
        style="height: 100vh; overflow-y: auto;"
      >
        <!-- Header -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card class="elevation-8" color="primary" dark>
              <v-card-title class="text-h4 justify-center py-6">
                <v-icon x-large left>mdi-clipboard-check</v-icon>
                สถานการณ์การรายงานตัวครูผู้ช่วย
              </v-card-title>
              <v-card-subtitle class="text-center text-h6 pb-4">
                รอบที่ {{ periodassteachs.periodAssTeachTimes }} /
                {{ periodassteachs.periodAssTeachYear }}
                <v-chip class="ml-4" color="white" text-color="primary" large>
                  <v-icon left>mdi-clock</v-icon>
                  {{ currentTime }}
                </v-chip>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <!-- Overall Statistics -->
        <v-row class="mb-4">
          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="blue darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-account-group</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.total }}
                </div>
                <div class="text-h6">จำนวนทั้งหมด</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="green darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-check-circle</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.reported }}
                </div>
                <div class="text-h6">รายงานตัวแล้ว</div>
                <v-progress-linear
                  :value="statistics.reportedPercent"
                  color="white"
                  height="8"
                  rounded
                  class="mt-2"
                ></v-progress-linear>
                <div class="text-caption mt-1">
                  {{ statistics.reportedPercent }}%
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="orange darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-account-clock</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.selected }}
                </div>
                <div class="text-h6">เลือกสถานศึกษาแล้ว</div>
                <v-progress-linear
                  :value="statistics.selectedPercent"
                  color="white"
                  height="8"
                  rounded
                  class="mt-2"
                ></v-progress-linear>
                <div class="text-caption mt-1">
                  {{ statistics.selectedPercent }}%
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="red darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-cancel</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.disclaim }}
                </div>
                <div class="text-h6">สละสิทธิ์</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Charts -->
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-chart-donut</v-icon>
                สัดส่วนสถานะ
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="donut"
                  height="350"
                  :options="donutChartOptions"
                  :series="donutChartSeries"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-chart-bar</v-icon>
                สถิติตามสาขาวิชา
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="bar"
                  height="350"
                  :options="barChartOptions"
                  :series="barChartSeries"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Recent Updates Table -->
        <v-row>
          <v-col cols="12">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-update</v-icon>
                รายการล่าสุด (10 รายการ)
              </v-card-title>
              <v-card-text class="pa-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr class="grey lighten-3">
                        <th class="text-center text-h6">ลำดับ</th>
                        <th class="text-center text-h6">สาขา</th>
                        <th class="text-h6">ชื่อ-นามสกุล</th>
                        <th class="text-h6">สถานศึกษา</th>
                        <th class="text-center text-h6">สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="teacher in recentTeachers"
                        :key="teacher.mt_id"
                        :class="getRowClass(teacher)"
                        style="font-size: 18px;"
                      >
                        <td class="text-center">
                          <v-chip color="primary" dark large label>
                            <strong>{{ teacher.mt_sequence }}</strong>
                          </v-chip>
                        </td>
                        <td class="text-center">
                          <v-chip color="info" dark>{{
                            teacher.mt_id_branch
                          }}</v-chip>
                        </td>
                        <td>
                          <strong>{{ teacher.mt_name }}</strong>
                        </td>
                        <td>{{ teacher.college_name || "-" }}</td>
                        <td class="text-center">
                          <v-chip :color="getStatusColor(teacher)" dark large>
                            <v-icon left>{{ getStatusIcon(teacher) }}</v-icon>
                            {{ getStatusText(teacher) }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Auto Refresh Indicator -->
        <v-snackbar
          v-model="showRefreshSnackbar"
          timeout="2000"
          color="success"
          bottom
          right
        >
          <v-icon left>mdi-refresh</v-icon>
          ข้อมูลอัพเดทแล้ว
        </v-snackbar>
      </v-container>
    </div>

    <!-- Admin Mode (Management View) -->
    <v-container v-else fluid class="admin-mode mt-4">
      <!-- Quick Statistics Cards -->
      <v-row class="mb-4">
        <v-col cols="12" md="3">
          <v-card class="elevation-2" color="blue lighten-5">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="blue darken-2" size="56" class="mr-4">
                  <v-icon dark size="32">mdi-account-group</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h4 font-weight-bold blue--text text--darken-2"
                  >
                    {{ statistics.total }}
                  </div>
                  <div class="text-subtitle-1">จำนวนทั้งหมด</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card
            class="elevation-2"
            color="green lighten-5"
            @click="statusFilter = 'reported'"
          >
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="green darken-2" size="56" class="mr-4">
                  <v-icon dark size="32">mdi-check-circle</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h4 font-weight-bold green--text text--darken-2"
                  >
                    {{ statistics.reported }}
                  </div>
                  <div class="text-subtitle-1">รายงานตัวแล้ว</div>
                  <v-progress-linear
                    :value="statistics.reportedPercent"
                    color="green darken-2"
                    height="4"
                    rounded
                    class="mt-1"
                  ></v-progress-linear>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card
            class="elevation-2"
            color="orange lighten-5"
            @click="statusFilter = 'selected'"
          >
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="orange darken-2" size="56" class="mr-4">
                  <v-icon dark size="32">mdi-school</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h4 font-weight-bold orange--text text--darken-2"
                  >
                    {{ statistics.selected }}
                  </div>
                  <div class="text-subtitle-1">เลือกสถานศึกษาแล้ว</div>
                  <v-progress-linear
                    :value="statistics.selectedPercent"
                    color="orange darken-2"
                    height="4"
                    rounded
                    class="mt-1"
                  ></v-progress-linear>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card
            class="elevation-2"
            color="red lighten-5"
            @click="statusFilter = 'disclaim'"
          >
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="red darken-2" size="56" class="mr-4">
                  <v-icon dark size="32">mdi-cancel</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h4 font-weight-bold red--text text--darken-2"
                  >
                    {{ statistics.disclaim }}
                  </div>
                  <div class="text-subtitle-1">สละสิทธิ์</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Charts in Admin Mode -->
      <v-row class="mb-4">
        <v-col cols="12" md="8">
          <v-card class="elevation-2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-bar</v-icon>
              สถิติแยกตามสาขาวิชา
            </v-card-title>
            <v-card-text>
              <apexchart
                type="bar"
                height="300"
                :options="barChartOptions"
                :series="barChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="elevation-2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-donut</v-icon>
              สัดส่วนสถานะ
            </v-card-title>
            <v-card-text>
              <apexchart
                type="donut"
                height="300"
                :options="donutChartOptions"
                :series="donutChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Main Management Card -->
      <base-material-card
        icon="mdi-account-star"
        :title="
          `ข้อมูลครูผู้ช่วย รายงานตัว รอบที่ : ${periodassteachs.periodAssTeachTimes} / ${periodassteachs.periodAssTeachYear}`
        "
        class="px-5 py-3"
      >
        <!-- Filter & Action Bar -->
        <v-card class="mb-4 pa-4" outlined>
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ชื่อ, เลขบัตร, สถานศึกษา"
                single-line
                hide-details
                dense
                outlined
                clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="SearchBranch"
                label="กรองตามสาขาวิชาเอก"
                outlined
                dense
                clearable
                :items="manage_assistant_teacherGroupBranch"
                item-text="name_branch"
                item-value="mt_id_branch"
                @change="manage_assistant_teacherSearchBranchQueryAll"
              >
                <template v-slot:selection="{ item }">
                  <v-chip small color="primary" label>
                    {{ item.name_branch }} ({{ item.countMAT }})
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ item.mt_id_branch }}</strong> -
                      {{ item.name_branch }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      จำนวน: {{ item.countMAT }} คน
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="statusFilter"
                label="สถานะการรายงานตัว"
                outlined
                dense
                clearable
                :items="statusFilterOptions"
              />
            </v-col>
          </v-row>

          <!-- Action Buttons -->
          <v-row class="mt-2">
            <v-col cols="12" class="d-flex flex-wrap">
              <v-btn
                color="info"
                depressed
                class="mr-2 mb-2"
                @click="manage_assistant_teacherTotal"
              >
                <v-icon left>mdi-chart-pie</v-icon>
                สรุปสถิติ
              </v-btn>

              <v-btn
                color="success"
                depressed
                class="mr-2 mb-2"
                @click="manage_assistant_teacherQueryAll"
              >
                <v-icon left>mdi-refresh</v-icon>
                รีเฟรชข้อมูล
              </v-btn>

              <v-btn
                color="warning"
                depressed
                class="mr-2 mb-2"
                @click="manage_assistant_teacherApprove"
              >
                <v-icon left>mdi-checkbox-multiple-marked</v-icon>
                ยืนยันประกาศ
              </v-btn>

              <v-btn
                :href="
                  `#/admin/print_manage_assistant_teacher_report/${periodassteachs.periodAssTeachTimes}/${periodassteachs.periodAssTeachYear}`
                "
                target="_blank"
                color="primary"
                depressed
                class="mb-2"
              >
                <v-icon left>mdi-printer</v-icon>
                พิมพ์รายงาน
              </v-btn>

              <v-btn color="primary" @click="exportToExcel()">
                <v-icon left>mdi-file-excel</v-icon>
                ส่งออกข้อมูลที่กรอง
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- Data Table -->
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filteredTeachers"
          :search="search"
          group-by="mt_id_branch"
          class="elevation-2"
          :item-class="row_classes"
          :items-per-page="25"
          :footer-props="{
            itemsPerPageOptions: [10, 25, 50, 100, -1],
            showFirstLastPage: true
          }"
        >
          <!-- Group Header -->
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th colspan="20" class="group-header">
              <v-btn icon small @click="toggle" class="mr-2">
                <v-icon>{{
                  isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <v-chip color="primary" dark label class="mr-2">
                {{ items[0].mt_id_branch }}
              </v-chip>
              <strong>{{ items[0].name_branch }}</strong>
              <v-chip small color="info" dark class="ml-2">
                {{ items.length }} คน
              </v-chip>
            </th>
          </template>

          <!-- Sequence -->
          <template v-slot:item.mt_sequence="{ item }">
            <v-chip dark color="info" label>
              <strong style="font-size: 16px;">{{ item.mt_sequence }}</strong>
            </v-chip>
          </template>

          <!-- ID Card (Masked) -->
          <template v-slot:item.mt_id_card="{ item }">
            <span class="hide-idcard-number">{{ item.mt_id_card }}</span>
          </template>

          <!-- Status -->
          <template v-slot:item.mt_status="{ item }">
            <v-chip :color="getStatusColor(item)" dark small label>
              <v-icon left small>{{ getStatusIcon(item) }}</v-icon>
              {{ getStatusText(item) }}
            </v-chip>
            <v-chip
              v-if="item.mt_examgroup === 'southern'"
              color="warning"
              dark
              x-small
              class="ml-1"
            >
              จชต.
            </v-chip>
          </template>

          <!-- College Selection -->
          <template v-slot:item.mt_college_code="{ item }">
            <div v-if="item.mt_id === editedItem.mt_id">
              <v-autocomplete
                v-model="editedItem.mt_college_code"
                :items="manage_college_manpowers"
                item-text="college_name"
                item-value="college_code"
                label="เลือกสถานศึกษา"
                dense
                outlined
                @change="
                  collegeIDpositionid(
                    item.mt_times,
                    item.mt_years,
                    editedItem.mt_college_code,
                    item.mt_id_branch
                  )
                "
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.college_name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.province_name }}
                      <v-chip
                        v-if="item.college_dif === '1'"
                        x-small
                        color="warning"
                        class="ml-1"
                      >
                        จชต.
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </div>
            <span v-else>
              {{ item.college_name }}
              <v-chip
                v-if="item.college_dif === '1'"
                x-small
                color="warning"
                class="ml-1"
              >
                จชต.
              </v-chip>
            </span>
          </template>

          <!-- Position ID -->
          <template v-slot:item.mt_id_position="{ item }">
            <div v-if="item.mt_id === editedItem.mt_id">
              <v-autocomplete
                v-model="editedItem.mt_id_position"
                label="เลขที่ตำแหน่ง"
                :items="manage_college_manpowerIDpostion"
                item-text="mcm_id_position"
                item-value="mcm_id_position"
                dense
                outlined
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title
                      ><strong>{{
                        item.mcm_id_position
                      }}</strong></v-list-item-title
                    >
                    <v-list-item-subtitle
                      >สถานะ:
                      {{
                        item.mcm_id_card_booking || "ว่าง"
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </div>
            <v-chip v-else small color="grey lighten-2" label>
              {{ item.mt_id_position }}
            </v-chip>
          </template>

          <!-- Quick Actions -->
          <template v-slot:item.actionSelect="{ item }">
            <div v-if="isEditable(item)">
              <div v-if="item.mt_id === editedItem.mt_id">
                <v-btn icon color="error" small @click="close">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-btn icon color="success" small @click="save">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn icon color="primary" small @click="editItem(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="error"
                  small
                  @click="deleteItem(item.mt_id, item.mt_id_position)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
            <v-chip v-else color="orange" dark small>
              <v-icon left small>mdi-check-circle</v-icon>
              รายงานตัวแล้ว
            </v-chip>
          </template>

          <!-- Edit Action -->
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="isEditable(item)"
              icon
              color="warning"
              @click="manage_assistant_teacherEdit(item.mt_id)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-icon v-else color="grey">mdi-lock</v-icon>
          </template>

          <!-- Delete Action -->
          <template v-slot:item.action_s="{ item }">
            <v-btn
              v-if="isEditable(item)"
              icon
              color="error"
              @click="manage_assistant_teacherDelete(item.mt_id)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-chip v-else color="orange" dark x-small>
              <v-icon x-small>mdi-lock</v-icon>
            </v-chip>
          </template>

          <!-- No Results -->
          <template v-slot:no-data>
            <v-alert type="info" outlined class="ma-4">
              <strong>ไม่พบข้อมูล</strong><br />
              ลองปรับเปลี่ยนตัวกรองหรือคำค้นหา
            </v-alert>
          </template>

          <template v-slot:no-results>
            <v-alert type="warning" outlined class="ma-4">
              ไม่พบผลลัพธ์สำหรับ "<strong>{{ search }}</strong
              >"
            </v-alert>
          </template>
        </v-data-table>
      </base-material-card>
    </v-container>

    <!-- Edit Dialog -->
    <v-dialog
      v-model="editmanage_assistant_teacherdialog"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-pencil</v-icon>
          แก้ไขข้อมูลครูผู้ช่วย
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="editmanage_assistant_teacherform" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  label="เลขบัตรประชาชน"
                  v-model="editmanage_assistant_teacher.mt_id_card"
                  required
                  :rules="[v => !!v || 'กรุณากรอกเลขบัตรประชาชน']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="branchs"
                  item-text="name_branch"
                  item-value="id_branch"
                  outlined
                  label="สาขาวิชา"
                  v-model="editmanage_assistant_teacher.mt_id_branch"
                  required
                  :rules="[v => !!v || 'กรุณาเลือกสาขาวิชา']"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.id_branch }} : {{ item.name_branch }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="คำนำหน้าชื่อ"
                  v-model="editmanage_assistant_teacher.mt_title_s"
                  required
                  :rules="[v => !!v || 'กรุณากรอกคำนำหน้า']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="ชื่อ"
                  v-model="editmanage_assistant_teacher.mt_frist_name"
                  required
                  :rules="[v => !!v || 'กรุณากรอกชื่อ']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="นามสกุล"
                  v-model="editmanage_assistant_teacher.mt_last_name"
                  required
                  :rules="[v => !!v || 'กรุณากรอกนามสกุล']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="วันเกิด"
                  v-model="editmanage_assistant_teacher.mt_brith_day"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="เดือนเกิด"
                  v-model="editmanage_assistant_teacher.mt_brith_month"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="ปีเกิด"
                  v-model="editmanage_assistant_teacher.mt_brith_year"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="เบอร์โทร"
                  v-model="editmanage_assistant_teacher.mt_tel_p"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="ชื่อย่อวุฒิการศึกษา"
                  v-model="editmanage_assistant_teacher.mt_ed_abb"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="สาขาวิชาเอก"
                  v-model="editmanage_assistant_teacher.mt_ed_name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="วันที่บรรจุ"
                  v-model="editmanage_assistant_teacher.mt_appoin_day"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="เดือนที่บรรจุ"
                  v-model="editmanage_assistant_teacher.mt_appoin_month"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  label="ปีที่บรรจุ"
                  v-model="editmanage_assistant_teacher.mt_appoin_year"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  label="คำสั่งที่"
                  v-model="editmanage_assistant_teacher.mt_order_app"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="mt_status_select"
                  item-text="text"
                  item-value="value"
                  outlined
                  label="สถานะ"
                  v-model="editmanage_assistant_teacher.mt_status"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="editmanage_assistant_teacherdialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="warning"
            @click="editmanage_assistant_teacherSubmit"
          >
            <v-icon left>mdi-content-save</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Statistics Dialog -->
    <v-dialog
      v-model="manage_assistant_teacherCountDialog"
      persistent
      max-width="1000px"
    >
      <v-card>
        <v-card-title class="green white--text">
          <v-icon left color="white">mdi-chart-pie</v-icon>
          สรุปสถิติครูผู้ช่วย รอบที่
          {{ periodassteachs.periodAssTeachTimes }}/{{
            periodassteachs.periodAssTeachYear
          }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :loading="loading"
            :headers="headersCount"
            :items="manage_assistant_teacherCount"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                color="info"
                @click="
                  matBranchQuery(
                    item.mt_times,
                    item.mt_years,
                    item.mt_id_branch
                  )
                "
              >
                <v-icon>mdi-account-search</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="grey"
            outlined
            @click="manage_assistant_teacherCountDialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve Dialog -->
    <v-dialog
      v-model="manage_assistant_teacherApproveDialog"
      persistent
      max-width="1200px"
    >
      <v-card>
        <v-card-title class="green white--text">
          <v-icon left color="white">mdi-checkbox-multiple-marked</v-icon>
          ยืนยันการรายงานตัวครูผู้ช่วย รอบที่
          {{ periodassteachs.periodAssTeachTimes }}/{{
            periodassteachs.periodAssTeachYear
          }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="searchApprove"
            append-icon="mdi-magnify"
            label="ค้นหา"
            single-line
            hide-details
            dense
            filled
            class="mb-4"
          />

          <v-data-table
            :loading="loading"
            :headers="headersApprove"
            :items="manage_assistant_teachers"
            :search="searchApprove"
            class="elevation-1"
          >
            <template v-slot:item.mt_sequence="{ item }">
              <v-chip dark color="info">
                <strong>{{ item.mt_sequence }}</strong>
              </v-chip>
            </template>

            <template v-slot:item.mt_id_card="{ item }">
              <span class="hide-idcard-number">{{ item.mt_id_card }}</span>
            </template>

            <template v-slot:item.mt_status="{ item }">
              <v-chip :color="getStatusColor(item)" dark small>
                <v-icon left small>{{ getStatusIcon(item) }}</v-icon>
                {{ getStatusText(item) }}
              </v-chip>
            </template>

            <template v-slot:item.mt_admissions_status="{ item }">
              <v-chip
                :color="
                  item.mt_admissions_status === 'send' ? 'success' : 'grey'
                "
                dark
                small
              >
                <v-icon left small>
                  {{
                    item.mt_admissions_status === "send"
                      ? "mdi-check-circle"
                      : "mdi-close-circle"
                  }}
                </v-icon>
                {{
                  item.mt_admissions_status === "send"
                    ? "ยืนยันแล้ว"
                    : "ยังไม่ยืนยัน"
                }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="primary"
            @click="manage_assistant_teacherApproveSubmit"
          >
            <v-icon left>mdi-check</v-icon>
            ยืนยันข้อมูล
          </v-btn>
          <v-btn
            large
            color="warning"
            @click="manage_assistant_teacherApproveCCSubmit"
          >
            <v-icon left>mdi-cancel</v-icon>
            ยกเลิกการยืนยัน
          </v-btn>
          <v-btn
            large
            outlined
            @click="manage_assistant_teacherApproveDialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve Confirmation Dialog -->
    <v-dialog
      v-model="manage_assistant_teacherApproveCFDialog"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-alert</v-icon>
          ยืนยันการรายงานตัว
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="manage_assistant_teacherApproveCFDialogform">
            <v-text-field
              filled
              rounded
              type="password"
              label="รหัสผ่าน"
              :rules="[v => v === '0612698358' || 'รหัสผ่านไม่ถูกต้อง']"
            ></v-text-field>
            <v-alert type="warning" prominent>
              <strong>คำเตือน!</strong><br />
              กรุณาตรวจสอบข้อมูลให้เรียบร้อยก่อนยืนยัน
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="manage_assistant_teacherApproveCFDialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="success"
            @click="manage_assistant_teacherApproveCFDialogSubmit"
          >
            <v-icon left>mdi-check</v-icon>
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cancel Approve Dialog -->
    <v-dialog
      v-model="manage_assistant_teacherApproveCCDialog"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="red white--text">
          <v-icon left color="white">mdi-cancel</v-icon>
          ยกเลิกการยืนยัน
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="manage_assistant_teacherApproveCCDialogform">
            <v-text-field
              filled
              rounded
              type="password"
              label="รหัสผ่าน"
              :rules="[v => v === '0612698358' || 'รหัสผ่านไม่ถูกต้อง']"
            ></v-text-field>
            <v-alert type="error" prominent>
              <strong>คำเตือน!</strong><br />
              ยกเลิกข้อมูลการยืนยันรายการ
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="manage_assistant_teacherApproveCCDialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="success"
            @click="manage_assistant_teacherApproveCCDialogSubmit"
          >
            <v-icon left>mdi-check</v-icon>
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import manageAssistantTeacherBarVue from "../../../components/admin/manageAssistantTeacherBar.vue";

import * as XLSX from "xlsx";

export default {
  name: "HRvecManageAssistantTeacher",

  components: {
    manageAssistantTeacherBarVue
  },

  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      viewMode: "admin", // admin or display
      isFullscreen: false,
      autoRefresh: false,
      refreshInterval: null,
      currentTime: "",
      showRefreshSnackbar: false,

      // Search & Filter
      search: "",
      searchApprove: "",
      SearchBranch: "",
      statusFilter: null,

      // Dialogs
      editmanage_assistant_teacherdialog: false,
      manage_assistant_teacherCountDialog: false,
      manage_assistant_teacherApproveDialog: false,
      manage_assistant_teacherApproveCFDialog: false,
      manage_assistant_teacherApproveCCDialog: false,

      // Data
      manage_assistant_teachers: [],
      manage_assistant_teacherGroupBranch: [],
      manage_assistant_teacherCount: [],
      editmanage_assistant_teacher: {},
      branchs: [],
      periodassteachs: {},
      manage_college_manpowers: [],
      manage_college_manpowerIDpostion: [],
      manage_college_manpowersMt_id: [],

      // Table Headers
      headers: [
        { text: "ลำดับ", value: "mt_sequence", align: "center", width: "80px" },
        { text: "สาขา", value: "mt_id_branch", align: "left" },
        { text: "ชื่อสาขา", value: "name_branch", align: "left" },
        { text: "เลขบัตร", value: "mt_id_card", align: "left" },
        { text: "ชื่อ-นามสกุล", value: "mt_name", align: "left" },
        { text: "สถานะ", value: "mt_status", align: "center" },
        {
          text: "เลือกสถานศึกษา",
          value: "actionSelect",
          align: "center",
          width: "200px"
        },
        { text: "วิทยาลัย", value: "mt_college_code", align: "left" },
        { text: "ตำแหน่ง", value: "mt_id_position", align: "center" },
        { text: "แก้ไข", value: "actions", align: "center", sortable: false },
        { text: "ลบ", value: "action_s", align: "center", sortable: false }
      ],

      headersCount: [
        { text: "รอบที่", value: "mt_times", align: "left" },
        { text: "ปี", value: "mt_years", align: "left" },
        { text: "รหัส", value: "mt_id_branch", align: "left" },
        { text: "สาขาวิชา", value: "branchName", align: "left" },
        { text: "จำนวน", value: "branchGroup", align: "center" },
        { text: "แสดง", value: "actions", align: "center" }
      ],

      headersApprove: [
        { text: "รอบที่", value: "mt_timeyear", align: "left" },
        { text: "สาขา", value: "mt_id_branch", align: "left" },
        { text: "ลำดับที่", value: "mt_sequence", align: "center" },
        { text: "รหัส", value: "mt_id_card", align: "left" },
        { text: "ชื่อ-นามสกุล", value: "mt_name", align: "left" },
        { text: "สถานะ", value: "mt_status", align: "center" },
        { text: "วิทยาลัย", value: "mt_college_code", align: "left" },
        { text: "ตำแหน่ง", value: "mt_id_position", align: "center" },
        {
          text: "สถานะการยืนยัน",
          value: "mt_admissions_status",
          align: "center"
        }
      ],

      statusFilterOptions: [
        { text: "ทั้งหมด", value: null },
        { text: "รอเลือก", value: "pending" },
        { text: "เลือกแล้ว", value: "selected" },
        { text: "รายงานตัวแล้ว", value: "reported" },
        { text: "สละสิทธิ์", value: "disclaim" }
      ],

      mt_status_select: [
        { text: "ปกติ", value: "normal" },
        { text: "สละสิทธิ์", value: "disclaim" }
      ],

      // Editing
      editedIndex: -1,
      editedItem: {
        mt_id: 0,
        mt_college_code: "",
        mt_id_position: "",
        statusAdd: ""
      },
      defaultItem: {
        mt_id: 0,
        mt_college_code: "",
        mt_id_position: "",
        statusAdd: "add"
      },

      // Update/Delete items
      deletedItemmat: {},
      deletedItemmcm: {},
      updatemanage_college_manpower: {},
      upadtemanage_assistant_teacher: {}
    };
  },

  computed: {
    statistics() {
      const total = this.manage_assistant_teachers.length;
      const reported = this.manage_assistant_teachers.filter(
        t =>
          t.mt_admissions_status === "send" ||
          t.mt_admissions_status === "receipt"
      ).length;
      const disclaim = this.manage_assistant_teachers.filter(
        t => t.mt_status === "disclaim"
      ).length;
      const selected = this.manage_assistant_teachers.filter(
        t =>
          t.mt_college_code &&
          t.mt_status !== "disclaim" &&
          t.mt_admissions_status !== "send" &&
          t.mt_admissions_status !== "receipt"
      ).length;
      const pending = total - reported - disclaim - selected;

      // Branch statistics
      const branchStats = {};
      this.manage_assistant_teachers.forEach(teacher => {
        if (!branchStats[teacher.mt_id_branch]) {
          branchStats[teacher.mt_id_branch] = {
            name: teacher.name_branch,
            total: 0,
            reported: 0,
            selected: 0,
            pending: 0,
            disclaim: 0
          };
        }
        branchStats[teacher.mt_id_branch].total++;
        if (
          teacher.mt_admissions_status === "send" ||
          teacher.mt_admissions_status === "receipt"
        ) {
          branchStats[teacher.mt_id_branch].reported++;
        } else if (teacher.mt_status === "disclaim") {
          branchStats[teacher.mt_id_branch].disclaim++;
        } else if (teacher.mt_college_code) {
          branchStats[teacher.mt_id_branch].selected++;
        } else {
          branchStats[teacher.mt_id_branch].pending++;
        }
      });

      return {
        total,
        reported,
        selected,
        pending,
        disclaim,
        reportedPercent: total > 0 ? Math.round((reported / total) * 100) : 0,
        selectedPercent: total > 0 ? Math.round((selected / total) * 100) : 0,
        branchStats
      };
    },

    filteredTeachers() {
      let filtered = this.manage_assistant_teachers;

      if (this.statusFilter) {
        filtered = filtered.filter(teacher => {
          switch (this.statusFilter) {
            case "pending":
              return (
                !teacher.mt_college_code &&
                teacher.mt_status !== "disclaim" &&
                teacher.mt_admissions_status !== "send" &&
                teacher.mt_admissions_status !== "receipt"
              );
            case "selected":
              return (
                teacher.mt_college_code &&
                teacher.mt_status !== "disclaim" &&
                teacher.mt_admissions_status !== "send" &&
                teacher.mt_admissions_status !== "receipt"
              );
            case "reported":
              return (
                teacher.mt_admissions_status === "send" ||
                teacher.mt_admissions_status === "receipt"
              );
            case "disclaim":
              return teacher.mt_status === "disclaim";
            default:
              return true;
          }
        });
      }

      return filtered;
    },

    recentTeachers() {
      return this.manage_assistant_teachers
        .filter(
          t =>
            t.mt_college_code ||
            t.mt_admissions_status === "send" ||
            t.mt_admissions_status === "receipt"
        )
        .slice(0, 10);
    },

    // Chart Data
    donutChartSeries() {
      return [
        this.statistics.reported,
        this.statistics.selected,
        this.statistics.pending,
        this.statistics.disclaim
      ];
    },

    donutChartOptions() {
      return {
        chart: {
          type: "donut",
          fontFamily: "Sarabun, sans-serif"
        },
        labels: ["รายงานตัวแล้ว", "เลือกแล้ว", "รอเลือก", "สละสิทธิ์"],
        colors: ["#4CAF50", "#FF9800", "#FFC107", "#F44336"],
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "ทั้งหมด",
                  fontSize: "18px",
                  fontWeight: 600
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " คน";
            }
          }
        }
      };
    },

    barChartSeries() {
      const branches = Object.keys(this.statistics.branchStats);
      return [
        {
          name: "รายงานตัวแล้ว",
          data: branches.map(b => this.statistics.branchStats[b].reported)
        },
        {
          name: "เลือกแล้ว",
          data: branches.map(b => this.statistics.branchStats[b].selected)
        },
        {
          name: "รอเลือก",
          data: branches.map(b => this.statistics.branchStats[b].pending)
        },
        {
          name: "สละสิทธิ์",
          data: branches.map(b => this.statistics.branchStats[b].disclaim)
        }
      ];
    },

    barChartOptions() {
      const branches = Object.keys(this.statistics.branchStats);
      return {
        chart: {
          type: "bar",
          stacked: true,
          fontFamily: "Sarabun, sans-serif",
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "13px",
                  fontWeight: 900
                }
              }
            }
          }
        },
        xaxis: {
          categories: branches.map(b => this.statistics.branchStats[b].name),
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        yaxis: {
          title: {
            text: "จำนวน (คน)"
          }
        },
        legend: {
          position: "top",
          fontSize: "14px"
        },
        colors: ["#4CAF50", "#FF9800", "#FFC107", "#F44336"],
        dataLabels: {
          enabled: true
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " คน";
            }
          }
        }
      };
    }
  },

  watch: {
    autoRefresh(val) {
      if (val) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    }
  },

  async mounted() {
    await this.initialize();
    this.updateTime();
    setInterval(this.updateTime, 1000);
  },

  beforeDestroy() {
    this.stopAutoRefresh();
  },

  methods: {
    exportToExcel() {
      // 1. เลือกข้อมูลที่จะส่งออก (ใช้ข้อมูลที่ผ่านการ Filter บนหน้าจอแล้ว)
      const rawData = this.filteredTeachers;

      if (rawData.length === 0) {
        swal.fire({
          icon: "warning",
          title: "ไม่พบข้อมูล",
          text: "ไม่มีข้อมูลที่ต้องการส่งออกในขณะนี้"
        });
        return;
      }

      // 2. แปลงโครงสร้างข้อมูลสำหรับ Excel
      const data = rawData.map(item => ({
        ลำดับ: item.mt_sequence,
        รหัสสาขา: item.mt_id_branch,
        สาขาวิชา: item.name_branch,
        เลขบัตรประชาชน: item.mt_id_card,
        "ชื่อ-นามสกุล": item.mt_name,
        เบอร์โทรศัพท์: item.mt_tel_p || "-",
        วุฒิการศึกษา: item.mt_ed_abb || "-",
        สถานะการรายงานตัว: this.getStatusText(item),
        สถานศึกษาที่เลือก: item.college_name || "-",
        เลขที่ตำแหน่ง: item.mt_id_position || "-",
        จังหวัด: item.province_name || "-",
        สถานะการยืนยันระบบ:
          item.mt_admissions_status === "send" ? "ยืนยันแล้ว" : "ยังไม่ยืนยัน",
        หมายเหตุ: item.mt_examgroup === "southern" ? "โครงการจชต." : ""
      }));

      // 3. สร้าง Workbook และ Worksheet
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "รายชื่อครูผู้ช่วย");

      // 4. ปรับความกว้างของคอลัมน์อัตโนมัติ
      const colWidths = [
        { wch: 8 }, // ลำดับ
        { wch: 10 }, // รหัสสาขา
        { wch: 25 }, // สาขาวิชา
        { wch: 20 }, // เลขบัตร
        { wch: 25 }, // ชื่อ-นามสกุล
        { wch: 15 }, // เบอร์โทร
        { wch: 15 }, // วุฒิ
        { wch: 18 }, // สถานะ
        { wch: 30 }, // สถานศึกษา
        { wch: 15 }, // ตำแหน่ง
        { wch: 15 }, // จังหวัด
        { wch: 18 }, // การยืนยัน
        { wch: 15 } // หมายเหตุ
      ];
      ws["!cols"] = colWidths;

      // 5. กำหนดชื่อไฟล์ (ตัวอย่าง: รายงานครูผู้ช่วย_รอบ_1_2567_2026-02-11.xlsx)
      const fileName = `รายงานครูผู้ช่วย_รอบ_${
        this.periodassteachs.periodAssTeachTimes
      }_${
        this.periodassteachs.periodAssTeachYear
      }_${new Date().toISOString().slice(0, 10)}.xlsx`;

      // 6. บันทึกไฟล์
      XLSX.writeFile(wb, fileName);

      this.showRefreshSnackbar = true; // แสดง Snackbar แจ้งเตือน
    },

    async initialize() {
      try {
        await this.periodassteachQuery();
        await this.branchQuery();
        await this.matCountQuery();
        await this.manage_assistant_teacherQueryAll();
        await this.manage_assistant_teacherGroupBranchQueryAll();
      } catch (error) {
        console.error("Initialization error:", error);
        swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถโหลดข้อมูลได้"
        });
      }
    },

    updateTime() {
      const now = new Date();
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      };
      this.currentTime = now.toLocaleDateString("th-TH", options);
    },

    // Auto Refresh
    toggleAutoRefresh() {
      this.autoRefresh = !this.autoRefresh;
    },

    startAutoRefresh() {
      this.refreshInterval = setInterval(async () => {
        await this.manage_assistant_teacherQueryAll();
        this.showRefreshSnackbar = true;
      }, 10000); // Refresh every 10 seconds
    },

    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },

    // Fullscreen
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        this.isFullscreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.isFullscreen = false;
        }
      }
    },

    // Status helpers
    getStatusColor(item) {
      if (item.mt_status === "disclaim") return "error";
      if (
        item.mt_admissions_status === "send" ||
        item.mt_admissions_status === "receipt"
      )
        return "success";
      if (item.mt_college_code) return "info";
      return "warning";
    },

    getStatusIcon(item) {
      if (item.mt_status === "disclaim") return "mdi-cancel";
      if (
        item.mt_admissions_status === "send" ||
        item.mt_admissions_status === "receipt"
      )
        return "mdi-check-circle";
      if (item.mt_college_code) return "mdi-school";
      return "mdi-clock-outline";
    },

    getStatusText(item) {
      if (item.mt_status === "disclaim") return "สละสิทธิ์";
      if (
        item.mt_admissions_status === "send" ||
        item.mt_admissions_status === "receipt"
      )
        return "รายงานตัวแล้ว";
      if (item.mt_college_code) return "เลือกแล้ว";
      return "รอเลือก";
    },

    isEditable(item) {
      return (
        item.mt_admissions_status !== "send" &&
        item.mt_admissions_status !== "receipt" &&
        item.mt_admissions_status !== "missing"
      );
    },

    row_classes(item) {
      if (item.mt_status === "disclaim") return "red lighten-4";
      if (
        item.mt_admissions_status === "send" ||
        item.mt_admissions_status === "receipt"
      )
        return "green lighten-5";
      if (item.mt_college_code) return "blue lighten-5";
      return "";
    },

    getRowClass(item) {
      if (item.mt_status === "disclaim") return "red lighten-3";
      if (
        item.mt_admissions_status === "send" ||
        item.mt_admissions_status === "receipt"
      )
        return "green lighten-4";
      if (item.mt_college_code) return "blue lighten-4";
      return "";
    },

    // Data loading methods
    async periodassteachQuery() {
      const result = await this.$http.post("periodassteach.php", {
        ApiKey: this.ApiKey,
        periodAssTeachEnablePro: "1"
      });
      this.periodassteachs = result.data;
    },

    async branchQuery() {
      const result = await this.$http.post("branch.php", {
        ApiKey: this.ApiKey
      });
      this.branchs = result.data;
    },

    async matCountQuery() {
      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times: this.periodassteachs.periodAssTeachTimes,
        mt_years: this.periodassteachs.periodAssTeachYear,
        mt_count: "Ok"
      });
      this.manage_assistant_teacherCount = result.data;
    },

    async manage_assistant_teacherQueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          mt_times: this.periodassteachs.periodAssTeachTimes,
          mt_years: this.periodassteachs.periodAssTeachYear,
          report_selete: "ok"
        });
        this.manage_assistant_teachers = result.data;
      } finally {
        this.loading = false;
      }
    },

    async manage_assistant_teacherSearchBranchQueryAll() {
      if (!this.SearchBranch) {
        await this.manage_assistant_teacherQueryAll();
        return;
      }

      this.loading = true;
      try {
        const result = await this.$http.post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          mt_times: this.periodassteachs.periodAssTeachTimes,
          mt_years: this.periodassteachs.periodAssTeachYear,
          mt_id_branch: this.SearchBranch
        });
        this.manage_assistant_teachers = result.data;
      } finally {
        this.loading = false;
      }
    },

    async manage_assistant_teacherGroupBranchQueryAll() {
      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times: this.periodassteachs.periodAssTeachTimes,
        mt_years: this.periodassteachs.periodAssTeachYear,
        mt_SELECTBranch: "Ok"
      });
      this.manage_assistant_teacherGroupBranch = result.data;
    },

    async matBranchQuery(mt_times, mt_years, mt_id_branch) {
      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times,
        mt_years,
        mt_id_branch
      });
      this.manage_assistant_teachers = result.data;
      this.manage_assistant_teacherCountDialog = false;
    },

    // Editing methods
    async editItem(item) {
      this.editedIndex = this.manage_assistant_teachers.indexOf(item);
      this.editedItem = Object.assign({}, item);

      const data = {
        ApiKey: this.ApiKey,
        mcm_times: item.mt_times,
        mcm_years: item.mt_years,
        mcm_id_branch: item.mt_id_branch
      };

      const result = await this.$http.post("manage_college_manpower.php", data);
      this.manage_college_manpowers = result.data;
    },

    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async collegeIDpositionid(
      mt_times,
      mt_years,
      mt_college_code,
      mt_id_branch
    ) {
      const result = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times: mt_times,
        mcm_years: mt_years,
        mcm_college_code: mt_college_code,
        mcm_id_branch: mt_id_branch
      });
      this.manage_college_manpowerIDpostion = result.data;
    },

    async save() {
      this.editedItem.ApiKey = this.ApiKey;
      Object.assign(
        this.manage_assistant_teachers[this.editedIndex],
        this.editedItem
      );

      const resultmat = await this.$http.post(
        "manage_assistant_teacherID.update.php",
        this.editedItem
      );

      this.updatemanage_college_manpower.ApiKey = this.ApiKey;
      this.updatemanage_college_manpower.mcm_times = this.editedItem.mt_times;
      this.updatemanage_college_manpower.mcm_years = this.editedItem.mt_years;
      this.updatemanage_college_manpower.mcm_id_position = this.editedItem.mt_id_position;
      this.updatemanage_college_manpower.mcm_id_card_booking = this.editedItem.mt_id_card;

      const resultmcm = await this.$http.post(
        "manage_college_manpowerID.update.php",
        this.updatemanage_college_manpower
      );

      if (resultmat.data.status && resultmcm.data.status) {
        swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        swal.fire({
          icon: "warning",
          title: "ทำรายการซ้ำ",
          showConfirmButton: false,
          timer: 1500
        });
      }

      await this.manage_assistant_teacherQueryAll();
      this.close();
    },

    // Delete
    async deleteItem(mt_id, mt_id_position) {
      this.deletedItemmat.ApiKey = this.ApiKey;
      this.deletedItemmat.mt_id = mt_id;
      this.deletedItemmat.mt_college_code = "";
      this.deletedItemmat.mt_id_position = "";

      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });

      this.manage_college_manpowersMt_id = result.data;
      this.deletedItemmcm.ApiKey = this.ApiKey;
      this.deletedItemmcm.mcm_times = this.manage_college_manpowersMt_id.mt_times;
      this.deletedItemmcm.mcm_years = this.manage_college_manpowersMt_id.mt_years;
      this.deletedItemmcm.mcm_id_position = mt_id_position;
      this.deletedItemmcm.mcm_id_card_booking = "";

      const college_name = `${this.manage_college_manpowersMt_id.mt_title_s}${this.manage_college_manpowersMt_id.mt_frist_name} ${this.manage_college_manpowersMt_id.mt_last_name} : ${this.manage_college_manpowersMt_id.college_name} : ${this.manage_college_manpowersMt_id.mt_id_position}`;

      const swalResult = await swal.fire({
        title: "คุณต้องการลบรายการนี้?",
        text: college_name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ลบรายการ",
        cancelButtonText: "ยกเลิก"
      });

      if (swalResult.isConfirmed) {
        await this.$http.post(
          "manage_assistant_teacher.update.php",
          this.deletedItemmat
        );
        await this.$http.post(
          "manage_college_manpower.update.php",
          this.deletedItemmcm
        );
        await this.manage_assistant_teacherQueryAll();

        swal.fire({
          icon: "success",
          title: "ลบข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    // Dialog handlers
    async manage_assistant_teacherTotal() {
      await this.matCountQuery();
      this.manage_assistant_teacherCountDialog = true;
    },

    async manage_assistant_teacherApprove() {
      this.manage_assistant_teacherApproveDialog = true;
    },

    async manage_assistant_teacherApproveSubmit() {
      this.manage_assistant_teacherApproveCFDialog = true;
    },

    async manage_assistant_teacherApproveCFDialogSubmit() {
      if (!this.$refs.manage_assistant_teacherApproveCFDialogform.validate()) {
        return;
      }

      this.upadtemanage_assistant_teacher.ApiKey = this.ApiKey;
      this.upadtemanage_assistant_teacher.mt_times = this.periodassteachs.periodAssTeachTimes;
      this.upadtemanage_assistant_teacher.mt_years = this.periodassteachs.periodAssTeachYear;
      this.upadtemanage_assistant_teacher.mt_admissions_status = "send";

      const resultmat = await this.$http.post(
        "manage_assistant_teacherApprove.update.php",
        this.upadtemanage_assistant_teacher
      );

      this.updatemanage_college_manpower.ApiKey = this.ApiKey;
      this.updatemanage_college_manpower.mcm_times = this.periodassteachs.periodAssTeachTimes;
      this.updatemanage_college_manpower.mcm_years = this.periodassteachs.periodAssTeachYear;
      this.updatemanage_college_manpower.mcm_status = "send";

      const resultmcm = await this.$http.post(
        "manage_college_manpowerApprove.update.php",
        this.updatemanage_college_manpower
      );

      if (resultmat.data.status && resultmcm.data.status) {
        swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }

      await this.manage_assistant_teacherQueryAll();
      this.manage_assistant_teacherApproveCFDialog = false;
      this.manage_assistant_teacherApproveDialog = false;
    },

    async manage_assistant_teacherApproveCCSubmit() {
      this.manage_assistant_teacherApproveCCDialog = true;
    },

    async manage_assistant_teacherApproveCCDialogSubmit() {
      if (!this.$refs.manage_assistant_teacherApproveCCDialogform.validate()) {
        return;
      }

      this.upadtemanage_assistant_teacher.ApiKey = this.ApiKey;
      this.upadtemanage_assistant_teacher.mt_times = this.periodassteachs.periodAssTeachTimes;
      this.upadtemanage_assistant_teacher.mt_years = this.periodassteachs.periodAssTeachYear;
      this.upadtemanage_assistant_teacher.mt_admissions_status = "";

      const resultmat = await this.$http.post(
        "manage_assistant_teacherApprove.update.php",
        this.upadtemanage_assistant_teacher
      );

      this.updatemanage_college_manpower.ApiKey = this.ApiKey;
      this.updatemanage_college_manpower.mcm_times = this.periodassteachs.periodAssTeachTimes;
      this.updatemanage_college_manpower.mcm_years = this.periodassteachs.periodAssTeachYear;
      this.updatemanage_college_manpower.mcm_status = "";

      const resultmcm = await this.$http.post(
        "manage_college_manpowerApprove.update.php",
        this.updatemanage_college_manpower
      );

      if (resultmat.data.status && resultmcm.data.status) {
        swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }

      await this.manage_assistant_teacherQueryAll();
      this.manage_assistant_teacherApproveCCDialog = false;
      this.manage_assistant_teacherApproveDialog = false;
    },

    async manage_assistant_teacherEdit(mt_id) {
      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      this.editmanage_assistant_teacherdialog = true;
    },

    async editmanage_assistant_teacherSubmit() {
      if (!this.$refs.editmanage_assistant_teacherform.validate()) {
        return;
      }

      this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
      if (this.editmanage_assistant_teacher.mt_status === "normal") {
        this.editmanage_assistant_teacher.mt_status = "";
      }

      const result = await this.$http.post(
        "manage_assistant_teacher.update.php",
        this.editmanage_assistant_teacher
      );

      if (result.data.status) {
        swal.fire({
          icon: "success",
          title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.manage_assistant_teacherQueryAll();
      } else {
        swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }

      this.editmanage_assistant_teacherdialog = false;
    },

    async manage_assistant_teacherDelete(mt_id) {
      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;

      const swalResult = await swal.fire({
        title: "คุณต้องการลบข้อมูลนี้?",
        text: `${this.editmanage_assistant_teacher.mt_name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก"
      });

      if (swalResult.isConfirmed) {
        this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
        const deleteResult = await this.$http.post(
          "manage_assistant_teacher.delete.php",
          this.editmanage_assistant_teacher
        );

        if (deleteResult.data.status) {
          swal.fire({
            icon: "success",
            title: "ดำเนินการลบข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          await this.manage_assistant_teacherQueryAll();
        } else {
          swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600;700&display=swap");

* {
  font-family: "Sarabun", sans-serif;
}

.hide-idcard-number {
  display: inline-block;
  font-family: "Courier New", monospace;
  position: relative;
  letter-spacing: 2px;
}

.hide-idcard-number::after {
  content: "X-XXXX-XXXXX-XX-X";
  background: white;
  position: absolute;
  left: 0;
  color: #999;
}

.group-header {
  background: linear-gradient(90deg, #f5f5f5 0%, #ffffff 100%);
  padding: 12px 16px !important;
  font-size: 16px;
}

.admin-mode {
  padding-top: 20px;
}

.display-mode {
  height: calc(100vh - 48px);
  overflow-y: auto;
  background: #f5f5f5;
}

/* Card hover effects */
.v-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Table styling */
.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

/* Chip animations */
.v-chip {
  transition: all 0.3s ease;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .text-h3 {
    font-size: 2rem !important;
  }

  .text-h4 {
    font-size: 1.5rem !important;
  }
}

@media (max-width: 600px) {
  .v-data-table {
    font-size: 12px;
  }

  .text-h3 {
    font-size: 1.5rem !important;
  }
}

/* Print styles */
@media print {
  .v-app-bar,
  .v-btn,
  .hide-on-print {
    display: none !important;
  }
}

/* Loading overlay */
.v-data-table__wrapper {
  position: relative;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
